import { render, staticRenderFns } from "./candidate-address.vue?vue&type=template&id=1686d7ed&"
import script from "./candidate-address.vue?vue&type=script&lang=js&"
export * from "./candidate-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports